/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "loreeltiapi",
            "endpoint": "https://s1vplevcfc.execute-api.us-east-2.amazonaws.com/master",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://lqwnpbebdzavhcc2ypuoxpjdoe.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-east-2:f77b57cd-5bff-4a2a-82fb-3ade8ad98da3",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_qvwkmdYPM",
    "aws_user_pools_web_client_id": "35cesrd5f3kgbbnbjdk63ai6u3",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "loreev2storage24cd6295054c4df4b5661676008c768e111250-master",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
